import { StyleProps } from "@hex-insights/core";
import { Badge } from "../../../../Components/Badge";
import { CourseAssessmentMark, CourseAssessmentSubmission } from "../../../../Utilities";
import styles from "./styles.module.css";

export type SubmissionStatusBadgeProps = {
	courseAssessmentSubmission: Pick<CourseAssessmentSubmission, "id"> | null | undefined;
	courseAssessmentMark: Pick<CourseAssessmentMark, "wasLate" | "isExcused"> | null | undefined;
} & Partial<StyleProps>;

export function SubmissionStatusBadge({
	courseAssessmentSubmission,
	courseAssessmentMark,
	style,
}: SubmissionStatusBadgeProps) {
	let text = "Not Turned In";
	let color = "var(--theme-colors__pink--very-light)";
	if (courseAssessmentSubmission) {
		if (courseAssessmentMark?.wasLate) {
			text = "Late";
			color = "var(--theme-colors__yellow--very-light)";
		} else {
			text = "Turned In";
			color = "var(--theme-colors__green--very-light)";
		}
	} else if (courseAssessmentMark?.isExcused) {
		text = "Excused";
		color = "var(--theme-colors__blue--very-light)";
	}

	return (
		<Badge backgroundColor={color} className={styles["submission-status-badge"]} style={style}>
			{text}
		</Badge>
	);
}
